//
//
//
//
//
//
//
//
//
//
//
//
//

import { Post } from "@/models";
import PostItem from '@/components/post_item/PostItem'

export default {
  created () {
    this.userId = this.$route.params.userId
    this.channelId = this.$route.params.channelId

    this.getPosts()
  },

  
  metaInfo() {
    return {
      title: this.posts !== null && this.posts[0] && (`${this.posts[0].channel.name}`) || " ",
      titleTemplate: null,
      meta: [{ name: "description", content: "个人中心" }]
    };
  },

  data () {
    return {
      posts: null,
      page: 1,
      perPage: 5,
      loading: false,
      userId: null,
      channelId: null
    }
  },

  scrollBottom () {
    this.getPosts()
  },

  methods: {
    getPosts () {
      if (this.loading) {
        return
      }
      this.loading = true

      Post.getUserPosts({
        userId: this.userId,
        channelId: this.channelId,
        page: this.page,
        perPage: this.perPage
      }).then((result) => {
        if (Array.isArray(result)) {
          this.posts = this.page == 1 && result || this.posts.concat(result)
          console.log(this.posts)
          this.page += 1
          this.loading = false
        } else {
          throw new TypeError('posts is not a array')
        }
      }).catch((err) => {
        this.loading = false
      })
    },
  },

  components: {
    PostItem
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-msg/UserPosts.vue